<template>
  <div class="dot__picker">
    <ul class="dot__picker-list">
      <li v-for="item in icons" :key="item" class="dot__picker-list-item" :class="{'is-selected': item ===selectedIcon}" @click="onPickItem(item)">
        <i class="material-icons">{{item}}</i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'dotPicker',
  props: ['modelItem'],
  created() {
    this.selectedIcon = this.modelItem.value
  },
  data() {
    return {
      'icons': [
        'lens', 'warning', 'info', 'report', 'place', 'remove_red_eye', 'wifi', 'info_outline', 'open_in_new',
        'arrow_back_ios', 'arrow_forward_ios', 'home', 'done', 'play_arrow', 'replay', 'star',
        'shopping_basket', 'loop', 'favorite', 'add', 'clear', 'list', 'arrow_back', 'arrow_forward', 'help_outline', 'help', 'live_help'
      ],
      'selectedIcon': ''
    }
  },
  methods: {
    onPickItem(item) {
      console.log('on pick item', item)
      this.selectedIcon = item
      this.modelItem.value = item
      this.$emit('pick', item)
    }
  }
}
</script>
